import { CabinetWrapper } from '../../shared/cabinet-wrapper';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useGetFactorDealRequestQuery } from '../../app/api';
import { SingleDeal } from '../../shared/single-deal';
import { useEffect, useState } from 'react';
import { useNotification } from '@/shared/contexts/NotificationContext';
import { getFetchEror } from '@/app/helpers';
import { Alert, Box, Tab, Tabs } from '@mui/material';
import { PageTitle } from '@/shared/page-title';
import { useTranslation } from 'react-i18next';
import ComponentWithLoader from '@/shared/ComponentWithLoader/ComponentWithLoader';
import SubjectInfoTabs from '@/shared/SubjectInfoTabs/SubjectInfoTabs';

export const SingleFactorRequestPage = () => {
  const { t } = useTranslation();
  const { id = '' } = useParams<{ id: string }>();
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const backUrl = searchParams.get('backUrl');

  const [tabIndex, setTabIndex] = useState(0);

  const { data, isLoading, error, refetch } = useGetFactorDealRequestQuery(
    { id },
    {
      skip: !id,
    }
  );

  useEffect(() => {
    if (error) {
      showNotification(getFetchEror(error), 'error');
      navigate('/factor/requests');
    }
  }, [error, data]);

  const renderTabContent = () => {
    if (!data) return null;
    switch (tabIndex) {
      case 1:
        return <SubjectInfoTabs tin={data.data.seller.tin} type='seller' />;
      case 2:
        return <SubjectInfoTabs tin={data.data.buyer.tin} type='buyer' />;
      default:
        return (
          <SingleDeal
            data={data?.data}
            type='factor'
            refetch={refetch}
            factorBranch={data?.factor?.branch}
          />
        );
    }
  };

  const tabs = [t('request_info'), t('supplier_info'), t('buyer_info')];

  return (
    <CabinetWrapper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        pb: 0,
      }}
    >
      {data ? (
        <ComponentWithLoader isLoading={isLoading}>
          <PageTitle
            title={t('bid') + ` №${data.data.number}`}
            date={data.data.createdAt}
            backUrl={encodeURIComponent(backUrl || '/factor/requests')}
          />

          <Tabs
            value={tabIndex}
            onChange={(_e, newValue) => setTabIndex(newValue)}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab} disableRipple />
            ))}
          </Tabs>

          <Box
            sx={{
              mt: 2,
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            {renderTabContent()}
          </Box>
        </ComponentWithLoader>
      ) : (
        error && <Alert severity='error'>{getFetchEror(error)}</Alert>
      )}
    </CabinetWrapper>
  );
};
